export default class DocDeleteParameter {
  constructor (id) {
    this.id = !_.isUndefined(id) ? id : null;
  }
}
